import { render, staticRenderFns } from "./addPoints.vue?vue&type=template&id=e7366830&scoped=true&"
import script from "./addPoints.vue?vue&type=script&lang=js&"
export * from "./addPoints.vue?vue&type=script&lang=js&"
import style0 from "./addPoints.vue?vue&type=style&index=0&id=e7366830&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7366830",
  null
  
)

export default component.exports